import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { HeroSection } from "./components/sections/HeroSection";
import { AboutSection } from "./components/sections/AboutSection";
import { TimelineSection } from "./components/sections/TimelineSection";
import { BookingSection } from "./components/sections/BookingSection";
import { AILeadershipSection } from "./components/sections/AILeadershipSection";
import { ContactSection } from "./components/sections/ContactSection";
import { AdminConsole } from "./components/AdminConsole";
import { Toaster } from "./components/ui/sonner";

const Portfolio = () => {
  return (
    <div className="relative" data-testid="portfolio-page">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <TimelineSection />
        <BookingSection />
        <AILeadershipSection />
        <ContactSection />
      </main>
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <div className="App min-h-screen bg-background text-foreground">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Portfolio />} />
            <Route path="/admin" element={<AdminConsole />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
